import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "error-container" }

import BaseError from '@/components/base/BaseError.vue'

interface Props {
  /** Field label for accessibility */
  label?: string | null
  /** Array of error messages to display */
  errors?: string[] | null
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'BaseErrors'
},
  __name: 'BaseErrors',
  props: {
    label: { default: null },
    errors: { default: () => ([]) }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors, (error, i) => {
      return (_openBlock(), _createBlock(BaseError, {
        key: i,
        label: __props.label,
        error: error
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(error), 1)
        ]),
        _: 2
      }, 1032, ["label", "error"]))
    }), 128))
  ], 512)), [
    [_vShow, __props.errors?.length]
  ])
}
}

})